import React, {Component} from 'react'
import Card from '../Card'
import Grid from '../Grid'
import { matchAndReturnGatsbyImage, matchAndReturnLink } from '../utils'
import './card-grid.css'

class CardGrid extends Component {

  render() {
    let cards = this.props.data.map(
      (datum, index) =>
        <div key={index}>
        <Card
          height = {this.props.height}
          link = {this.props.links ? matchAndReturnLink(this.props.links, datum.href) : null}
          data={datum} fluid={matchAndReturnGatsbyImage(this.props.images, datum.src)}>
        </Card>
        </div>
    );

    return (
      <Grid
        data = {cards}
        nCellsPerRow = {this.props.nCellsPerRow}
        nCellsPerRowMobile = {this.props.nCellsPerRowMobile}
      ></Grid>
    );
  }
}

export default CardGrid
